// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox_checkbox{height:15px;width:15px;display:flex;justify-content:center;align-items:center;background:#ffffff;cursor:pointer;border:1px solid #979797;box-shadow:1px 1px 1px 0 rgba(0,0,0,0.25),inset 0 1px 1px 0 rgba(0,0,0,0.25)}.checkbox_disabled{pointer-events:none;opacity:0.5}.checkbox_check::after{content:\"\\2713\";opacity:0;font-size:1em;font-weight:bolder;color:#1cbcc3}.active::after{opacity:1;transition:0.25s}\n", ""]);
// Exports
module.exports = exports;
